export default __webpack_public_path__ + "static/501c3-c56dc1ee9c77935d11471e58656c3be4.png";